module.exports = __webpack_public_path__ + "img/ZWF_Mirek_Kozlowski.5cb19570.jpg";